import { FC } from 'react';

type Props = {
	className?: string;
};

const CancelCircleIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M12.4011 12.4001L7.60156 7.6001M7.60207 12.4001L12.4016 7.6001'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.0002 10.0001C18.0002 5.58176 14.4184 2 10.0001 2C5.58176 2 2 5.58176 2 10.0001C2 14.4184 5.58176 18.0002 10.0001 18.0002C14.4184 18.0002 18.0002 14.4184 18.0002 10.0001Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
		</svg>
	);
};

export default CancelCircleIcon;
